import i18n from 'client/i18n'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { createButtonNew } from 'src/shared/entities/button/create-button'
import { insertChild } from 'src/shared/entities/utils/generate-base-entity'
import { ContainerBaseEntityUnionInterface } from 'src/shared/schemas/container-base-entity.schema'
import { WebsiteButtonInterface } from 'src/shared/types/entities/website-button-interface'
import { getDefaultButtonSettings } from 'src/shared/utils/website-header-utils'

export const createWebsiteButtonFromLibrary = ({
  container,
  locale,
  position = 0,
  options,
  createButton = createButtonNew,
}: {
  container: ContainerBaseEntityUnionInterface | OldEntityWithChildIds
  locale: string
  position?: number
  options?: Partial<WebsiteButtonInterface>
  createButton?: typeof createButtonNew
}) => {
  const fixedT = i18n.getFixedT(locale)

  const button = createButton(
    container.id,
    fixedT('entities.button.default_text'),
    '',
    container.masterBlockId,
  )

  return {
    [container.id]: {
      ...container,
      childIds: insertChild(container.childIds, button.id, position),
    },
    [button.id]: {
      ...button,
      ...options,
      ...getDefaultButtonSettings,
    },
  }
}
